/* eslint-disable import/prefer-default-export */
import {
  capitalize as muiCapitalize,
} from '@material-ui/core';

export const capitalize = muiCapitalize;

export const createCustomColoring = (theme, prefix, colorMap, styleFn) => {
  return Object.keys(colorMap).reduce((acc, curr) => {
    return {
      ...acc,
      [`${prefix}${capitalize(curr)}`]: styleFn(theme, colorMap[curr]),
    };
  }, {});
};
